import { ORDER_TYPES } from '../../helpers/constants';
import { TOrderRefundDetails } from '../../types/bundle.types';
import { getLatestOrderOfOrderType } from '../../helpers/product.helpers';

export enum REFUND_FOR {
  BUNDLE = 'bundle',
  MAIL = 'mail',
  SITE = 'site',
}

export enum REFUND_ACTIONS {
  DELETE_BUNDLE = 'deleteBundle',
  DELETE_MAIL = 'deleteMail',
  DELETE_SITE = 'deleteSite',
  ADVANCE_REFUND = 'advanceRefund',
}

export const getRefundActionForPayload = (
  refundAction: (typeof REFUND_ACTIONS)[keyof typeof REFUND_ACTIONS],
  isAccountLimitChange: boolean
) => {
  if (refundAction === REFUND_ACTIONS.DELETE_BUNDLE) {
    return 'DeleteBundle';
  }

  if (
    refundAction === REFUND_ACTIONS.DELETE_MAIL ||
    refundAction === REFUND_ACTIONS.DELETE_SITE
  ) {
    return 'DeleteOrder';
  }

  if (refundAction === REFUND_ACTIONS.ADVANCE_REFUND) {
    return isAccountLimitChange ? 'AccountLimitChange' : 'PlanChange';
  }
};

export const hasTransactionsForOrder = (
  orderRefundDetails: TOrderRefundDetails[],
  orderType: string
): boolean => {
  return !!orderRefundDetails.find(
    (order: { orderType: string }) => order.orderType === orderType
  );
};

export const getRefundForOptions = (orderRefundDetails: any) => {
  const _hasMailOrderTransactions = hasTransactionsForOrder(
    orderRefundDetails,
    ORDER_TYPES.MAIL
  );
  const _hasSiteOrderTransactions = hasTransactionsForOrder(
    orderRefundDetails,
    ORDER_TYPES.SITE
  );

  const refundForOptions = [];

  if (_hasMailOrderTransactions) {
    refundForOptions.push({
      label: _hasSiteOrderTransactions ? 'Mail' : 'Bundle',
      value: !_hasSiteOrderTransactions ? REFUND_FOR.BUNDLE : REFUND_FOR.MAIL,
    });
  }

  if (_hasSiteOrderTransactions) {
    refundForOptions.push({
      label: _hasMailOrderTransactions ? 'Site' : 'Bundle',
      value: !_hasMailOrderTransactions ? REFUND_FOR.BUNDLE : REFUND_FOR.SITE,
    });
  }

  if (_hasMailOrderTransactions && _hasSiteOrderTransactions) {
    refundForOptions.splice(0, 0, {
      label: 'Bundle',
      value: REFUND_FOR.BUNDLE,
    });
  }
  return refundForOptions;
};

export const getOrderPlanOptions = (
  plans: any,
  orderType: (typeof ORDER_TYPES)[keyof typeof ORDER_TYPES]
) => {
  return plans.filter((p: any) => p.orderType === orderType);
};

export const getCurrentPlanForOrder = (
  plans: any,
  orders: any,
  orderType: (typeof ORDER_TYPES)[keyof typeof ORDER_TYPES]
) => {
  return plans.filter(
    (p: any) =>
      p.orderType === orderType &&
      p.id === getLatestOrderOfOrderType(orders, orderType)?.plan.id
  );
};

export const refundActionsOptions = [
  {
    label: 'Delete Bundle',
    value: REFUND_ACTIONS.DELETE_BUNDLE,
    showFor: REFUND_FOR.BUNDLE,
  },
  {
    label: 'Delete Mail',
    value: REFUND_ACTIONS.DELETE_MAIL,
    showFor: REFUND_FOR.MAIL,
  },
  {
    label: 'Delete Site',
    value: REFUND_ACTIONS.DELETE_SITE,
    showFor: REFUND_FOR.SITE,
  },
  {
    label: 'Advance Refund',
    value: REFUND_ACTIONS.ADVANCE_REFUND,
    showFor: true,
  },
];

export const getFullBundleRefundAmount = (
  orderRefundDetails: Array<TOrderRefundDetails>
) => {
  return orderRefundDetails.reduce((acc, order) => {
    return acc + order.refundableAmount;
  }, 0);
};
